export default class HeroSwipper {
  constructor() {
    if(!$('.swiper').length) return;
    const swiper = new Swiper('.swiper', { // eslint-disable-line
      speed: 1300,
      spaceBetween: 0,
      // slidesPerView: 1,
      centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
      loop: true,
      // allowSlideNext: true,
      // allowSlidePrev: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/components/hero.js